import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD746698lTtgRRFy9MDesJbI9haHbJF0a0",
  authDomain: "refreshh20-c0c4a.firebaseapp.com",
  projectId: "refreshh20-c0c4a",
  databaseURL: "https://refreshh20-c0c4a-default-rtdb.firebaseio.com/", // 👈 Add this line
  storageBucket: "refreshh20-c0c4a.firebasestorage.app",
  messagingSenderId: "878978710340",
  appId: "1:878978710340:web:b44cd9a505c2f1a7027511",
    measurementId: "G-6TP1ZZ66M6"

};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app); // 👈 Realtime DB export
export default app;
